export default "__VITE_ASSET__XIYfM47L__"